<template>
  <div
    data-sidebar="content"
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-auto group-data-[collapsible=icon]:overflow-hidden"
  >
    <slot />
  </div>
</template>
